class Debounce {
	static timeouts = {};

	static debounce(key, callback, delay = 200) {
		Debounce.timeouts[key] ? clearTimeout(Debounce.timeouts[key]) : null;
		Debounce.timeouts[key] = setTimeout(() => {
			callback();
			delete Debounce.timeouts[key];
		}, delay);
	}

	static cancel(key) {
		if (Debounce.timeouts[key]) {
			clearTimeout(Debounce.timeouts[key]);
			delete Debounce.timeouts[key];
		}
	}

	static cancelAll() {
		Object.keys(Debounce.timeouts).forEach(this.cancel.bind(this));
	}
}

export default Debounce;